export const EDIT_LOCK_MOTION_SETTINGS = 'editLockMotionSettings';
export const FETCH_LOCK_MOTION_SETTINGS = 'fetchLockMotionSettings';
export const LOCK_MOTION_SETTINGS_CUSTOM_ID = 'lockMotionSettingsCustom';
export const LOCK_MOTION_SETTINGS_PRESET_1_ID = 'lockMotionSettingsPreset1';
export const LOCK_MOTION_SETTINGS_PRESET_1_LONG_MOTION_DURATION = 15;
export const LOCK_MOTION_SETTINGS_PRESET_1_SHORT_MOTION_COUNTS = 2;
export const LOCK_MOTION_SETTINGS_PRESET_1_SHORT_MOTION_DURATION = 6;
export const LOCK_MOTION_SETTINGS_PRESET_2_ID = 'lockMotionSettingsPreset2';
export const LOCK_MOTION_SETTINGS_PRESET_2_LONG_MOTION_DURATION = 20;
export const LOCK_MOTION_SETTINGS_PRESET_2_SHORT_MOTION_COUNTS = 2;
export const LOCK_MOTION_SETTINGS_PRESET_2_SHORT_MOTION_DURATION = 9;
export const LOCK_MOTION_SETTINGS_PRESET_3_ID = 'lockMotionSettingsPreset3';
export const LOCK_MOTION_SETTINGS_PRESET_3_LONG_MOTION_DURATION = 25;
export const LOCK_MOTION_SETTINGS_PRESET_3_SHORT_MOTION_COUNTS = 3;
export const LOCK_MOTION_SETTINGS_PRESET_3_SHORT_MOTION_DURATION = 12;
export const LOCK_MOTION_SETTINGS_PRESET_4_ID = 'lockMotionSettingsPreset4';
export const LOCK_MOTION_SETTINGS_PRESET_4_LONG_MOTION_DURATION = 30;
export const LOCK_MOTION_SETTINGS_PRESET_4_SHORT_MOTION_COUNTS = 3;
export const LOCK_MOTION_SETTINGS_PRESET_4_SHORT_MOTION_DURATION = 15;
export const LOCK_MOTION_SETTINGS_REPEATED_MOTION_MIN = 5;
export const LOCK_MOTION_SETTINGS_TIME_BEFORE_STOP = 180;
export const LOCK_MOTION_SETTINGS_VALIDATION_LONG_MOTION_DURATION_MAX = 255;
export const LOCK_MOTION_SETTINGS_VALIDATION_LONG_MOTION_DURATION_MIN = 15;
export const LOCK_MOTION_SETTINGS_VALIDATION_SHORT_MOTION_COUNTS_MAX = 255;
export const LOCK_MOTION_SETTINGS_VALIDATION_SHORT_MOTION_COUNTS_MIN = 1;
export const LOCK_MOTION_SETTINGS_VALIDATION_SHORT_MOTION_DURATION_MAX = 255;
export const LOCK_MOTION_SETTINGS_VALIDATION_SHORT_MOTION_DURATION_MIN = 5;
export const LOCK_MOTION_SETTINGS_WINDOW_TIME = 120;
export const SET_LOCK_MOTION_SETTINGS = 'setLockMotionSettings';
